export default __webpack_public_path__ + "b947ea4b09a80a48fa7c0c50989a20a4.png";